export default "__VITE_ASSET__BZTnT1h0__"